export const fileTypes = [
  // { value: 'pdf', label: 'Portable Document Format (PDF)' },
  { value: 'xlsx', label: 'Excel (XLSX)' },
  { value: 'csv', label: 'Valores Separados por Vírgulas (CSV)' },
];
